import $ from "jquery";
export default class CheckBoxGroup {
    static mount() {
        let $inputs = $("input[type=checkbox][data-groupid]");
        $inputs.on("change", function () {
            let $checkedInput = $(this);
            let groupId = $checkedInput.data("groupid");
            if ($checkedInput.is(":checked")) {
                let others = $("input[type=checkbox][data-groupid='" + groupId + "']");
                others.each(function () {
                    if ($checkedInput[0] != this) {
                        $(this).prop("checked", false);
                    }
                });
            }
        });
    }
}
